import _pick from 'lodash/pick';
import { TSegmentFormData } from './types';

export const dehydrateFormData = (formData: any) => {
	const csvData = {
		...formData
	};

	return { csvData };
};

export const hydrateFormData = (data: any): TSegmentFormData => {
	const hydratedData = {
		..._pick(data, ['useCase', 'expName', 'desc', 'csv'])
	};

	return hydratedData;
};
